import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { InfoStoreModule } from '@wonder-core-ng/info-store/info-store.module';
import { AuthHttpInterceptor } from '@wonder-core-ng/session-store/auth-http.interceptor.service';
import { QueryEngineApiService } from './query-engine.api.service';
import { QueryEngineEffects } from './query-engine.effects';
import * as fromQueryEngine from './query-engine.reducer';
import { QueryEngineService } from './query-engine.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromQueryEngine.queryEngineFeatureKey, fromQueryEngine.reducer),
    EffectsModule.forFeature([QueryEngineEffects]),
    InfoStoreModule,
  ],
  providers: [
    QueryEngineApiService,
    QueryEngineService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class QueryEngineModule {}
